import Component from '../../js/_Component';
import BaseCarousel from '../BaseCarousel/_BaseCarousel';
import ResizeClasses from '../../js/util/_ResizeClasses';

const CNAME = 'c-block-homepage-banner';

export default class BlockHomepageBanner extends Component {

	private carousel: BaseCarousel;

	constructor(element: HTMLElement) {
		super(element);

		this.carousel = Component.getComponent(this.element.querySelector('.c-base-carousel')) as BaseCarousel;

		this.element.querySelector(`.${CNAME}--carousel-button-container`).appendChild(this.carousel.getDotsContainer());

		new ResizeClasses(this.element, {
			'm-mobile-mode': {
				max: 1080,
			}
		});
	}
}

Component.register(BlockHomepageBanner, 'BlockHomepageBanner');
